import { getConfigValue } from "./Hosts";

export const WALLET_URLS = {
    RETURN_URL: getConfigValue("RETURN_URL", "https://payments.swiggy.com/wallet/money-received"),
    TXN_RETURN_URL: getConfigValue("TXN_RETURN_URL", "https://payments.swiggy.com/payment/transaction-received"),
    PAYMENT_MODE_ADD_MONEY_RETURN_URL: getConfigValue(
        "PAYMENT_MODE_ADD_MONEY_RETURN_URL",
        "https://payments.swiggy.com/payment-modes/wallet-detail/money-received",
    ),
    PAYTM_CALLBACK_URL: getConfigValue("PAYTM_CALLBACK_URL", "https://payments.swiggy.com/wallet/money-received"),
};

export const WALLET_CONFIG = {
    // MobiKwik Configuration
    MOBIKWIK_GATEWAY_URL: getConfigValue("MOBIKWIK_GATEWAY_URL", "https://walletapi.mobikwik.com/addmoneytowallet"),
    MOBIKWIK_MERCHANT_NAME: getConfigValue("MOBIKWIK_MERCHANT_NAME", "Swiggy"),
    MOBIKWIK_MID: getConfigValue("MOBIKWIK_MID", "MBK6868"),
};
